const PORTAL_LINK_SCHEMA_PREFIX = {
    dev: "dev",
    stage: "stage"
};

export const getLinkToPortal = (hostname) => {
    if (hostname.includes(PORTAL_LINK_SCHEMA_PREFIX.dev)) {
        return "https://portal.dev.ezerfinance.com";
    }

    if (hostname.includes(PORTAL_LINK_SCHEMA_PREFIX.stage)) {
        return "https://portal.stage.ezerfinance.com";
    }

    return "https://portal.ezerfinance.com";
};
